/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_Error_FieldsInputs */

const en_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter both role and location.`)
};

const de_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib sowohl Rolle als auch Standort ein.`)
};

const fr_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre à la fois le poste et le lieu.`)
};

const es_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, ingrese tanto el puesto como la ubicación.`)
};

const it_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci sia il ruolo che la posizione.`)
};

const nl_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul zowel rol als locatie in.`)
};

const pl_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj zarówno rolę, jak i lokalizację.`)
};

const fi_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä sekä tehtävä että sijainti.`)
};

const da_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast venligst både rolle og lokation.`)
};

const sv_salary_search_error_fields = /** @type {(inputs: Salary_Search_Error_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange både roll och plats.`)
};

/**
* | output |
* | --- |
* | "Please enter both role and location." |
*
* @param {Salary_Search_Error_FieldsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_error_fields = /** @type {((inputs?: Salary_Search_Error_FieldsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_Error_FieldsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_error_fields(inputs)
	if (locale === "fr") return fr_salary_search_error_fields(inputs)
	if (locale === "es") return es_salary_search_error_fields(inputs)
	if (locale === "it") return it_salary_search_error_fields(inputs)
	if (locale === "nl") return nl_salary_search_error_fields(inputs)
	if (locale === "pl") return pl_salary_search_error_fields(inputs)
	if (locale === "fi") return fi_salary_search_error_fields(inputs)
	if (locale === "da") return da_salary_search_error_fields(inputs)
	if (locale === "sv") return sv_salary_search_error_fields(inputs)
	return en_salary_search_error_fields(inputs)
});